const MAIN_URL = "https://george-fx.github.io/nuton_api/";

export const GET_COUPONS = `${MAIN_URL}api/coupons.json`;
export const GET_COURSES = `${MAIN_URL}api/courses.json`;
export const GET_BANNERS = `${MAIN_URL}api/banners.json`;
export const GET_CATEGORIES = `${MAIN_URL}api/categories.json`;

export const URLS = {
  GET_BANNERS,
  // GET_COURSES,
  GET_COUPONS,
  GET_CATEGORIES,
};
